import React from 'react';
import { IIcon, RightChevron } from '.';

const SVG = (props: IIcon & { rotate?: number }) => <RightChevron rotate={180} {...props} />;

export default SVG;
